import { List } from "immutable";
import { ANWSER_SELECTED_STATUS } from "mifid/constants/constants";

const getAllQuestionsFromCategories = (data) => {
    let allQuestions = List();
    let answeredQuestions = List();
    let unansweredQuestions = List();

    data.forEach((category) => {
        category.get("subCategories").forEach((subCategory) => {
            subCategory.get("sections").forEach((section) => {
                section.get("questions").forEach((question) => {
                    allQuestions = allQuestions.push(question);
                    const isAnswered = question
                        .get("answer")
                        .some((answer) => answer.get("selected") === ANWSER_SELECTED_STATUS);
                    if (isAnswered) {
                        answeredQuestions = answeredQuestions.push(question);
                    } else {
                        unansweredQuestions =
                            unansweredQuestions.push(question);
                    }
                });
            });
        });
    });

    return { allQuestions, answeredQuestions, unansweredQuestions };
};

const b64toBlob = (b64Data, typeContent) => {
    const byteCharacters = atob(b64Data);
    let byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512),
            byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }
    
    const blob = new Blob(byteArrays, { type: typeContent });

    return blob;
};

module.exports = {
    b64toBlob,
    getAllQuestionsFromCategories,
};
